window.addEventListener('click', e => {
  const btn = e.target.closest('.collection--description--read-more-btn');
  if (btn) {
    btn.parentNode.querySelector('.collection--description--read-more').classList.toggle('hc-open');
    const tog = btn.dataset.toggleText;
    btn.dataset.toggleText = btn.innerHTML;
    btn.innerHTML = tog;
    e.preventDefault();
  }
});
/** HC - integrate size app - 14 Oct '21 **/
(function () {
  window.addEventListener('click', e => {
    const btn = e.target.closest('.product--sizing-chart-heading'); 
    if (btn) {
      btn.classList.toggle('size-chart-closed');
      btn.closest('.product--sizing-chart').querySelector('[data-app="eastsideco_sizeGuides"]').style.display = btn.classList.contains('size-chart-closed') ? 'block' : 'none';
    }
  });
})();

// $( document ).ready(function() {
//   // FEATURED PRODUCT MOBILE SLIDER  
//   $('.featured-product-row').slick({
//     dots: true,
//     infinite: false,
//     arrows:true,
//     prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
//     nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
//     speed: 300,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     mobileFirst: true, 
//     responsive: [
//       {
//         breakpoint: 767,
//         settings: "unslick"
//       }
//     ]
//   });
// });  
// HC - Update SKU - 26 Oct '21
document.addEventListener('variant:change', e => {
  const variant = e.detail.variant;
  document.querySelectorAll('[data-product-sku]').forEach(el => {
    el.innerHTML = variant.sku;
  })
});
